 <template>
  <div>
    <div id="vismcfx" ref="vismcfx" :style="{ width: '100%', height: '400px' }"></div>
  </div>
</template>
<script>
// 引入基本模板
let echarts = require("echarts/lib/echarts");
// 引入柱状图组件
require("echarts/lib/chart/bar");
require("echarts/lib/chart/line");
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
require("echarts/lib/component/legend");
require("echarts/lib/component/dataZoom");
require("echarts/lib/component/grid");
require("echarts/lib/chart/line");
// require('echarts/lib/component/markPoint');
// require('echarts/lib/component/axisPointer');

export default {
  props: {
    regBase1: { Type: Object, default: () => {} },
  },

  data() {
    return {};
  },
  created() {},
  mounted() {
    this.register();
  },

  methods: {
    register() {
      if (this.$refs.vismcfx) {
        setTimeout(() => {
          // 基于准备好的dom，初始化echarts实例
          let myChart = echarts.init(this.$refs.vismcfx);
          // 绘制图表
          myChart.setOption({
            title: {
              text: this.regBase1.name,
              // subtext:this.regBase.name,
              left: "center",
              top: 0,
              textStyle: {
                //文字颜色
                color: "#fff",
                fontStyle: "normal",
                fontSize: 22,
              },
            },
            legend: {
              data: [
                "订单数量",
                "最高单价",
                "最低单价",
                "去年最高",
                "去年最低",
              ],
              left: "center",
              top: 50,
              textStyle: {
                //文字颜色
                color: "#fff",
                fontStyle: "normal",
              },
            },
            color: ["#4472c4", "#ed7d31", "#a5a5a5", "#ffc000", "#5b9bd5"],
            tooltip: {
              trigger: "axis",
              textStyle: {
                align: "left",
              },
              axisPointer: {
                type: "line",
              },
              // formatter: "{b0}<br/>{a0}:{c0}",
            },

            grid: {
              x: 45,
              y: 100,
              x2: 70,
              y2: 20,
            },

            xAxis: [
              {
                type: "category",
                data: this.regBase1.imonth,
                splitLine: {
                  show: false, //是否背景网格线
                },
                axisLabel: {
                  color: "#fff", // x轴字体颜色
                  interval: 0, //轴显示所有的数据
                },
                axisLine: {
                  lineStyle: {
                    color: "#35e4f9", // 颜色
                  },
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                // name: "订单",
                min: 0,
                // max: 100 * 8,
                axisLabel: {
                  color: "#fff", // x轴字体颜色
                  interval: 0, //轴显示所有的数据
                  formatter: "{value}",
                },
                splitLine: {
                  //分割线配置
                  show: false,
                  lineStyle: {
                    color: "#35e4f9",
                  },
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: "#35e4f9", // 颜色
                  },
                },
              },
              {
                type: "value",
                // name: "单价",
                splitNumber: 7,
                min: 0,
                // max: 200 * 8,
                axisLabel: {
                  color: "#fff", // x轴字体颜色
                  interval: 0, //轴显示所有的数据
                  formatter: "{value}",
                },
                splitLine: {
                  //分割线配置
                  show: false,
                  lineStyle: {
                    color: "#35e4f9",
                  },
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: "#35e4f9", // 颜色
                  },
                },
              },
            ],
            series: [
              {
                name: "订单数量",
                type: "bar",
                barWidth: 15,
                yAxisIndex: "1",
                data: this.regBase1.vcont1,
                itemStyle: {
                  normal: {
                    lineStyle: {
                      color: "#fff",
                    },
                  },
                },
              },
              {
                name: "最高单价",
                type: "line",
                smooth: true,
                data: this.regBase1.vcont2,
                itemStyle: {
                  normal: {
                    lineStyle: {
                      color: "#ed7d31",
                    },
                  },
                },
              },
              {
                name: "最低单价",
                type: "line",
                smooth: true,
                data: this.regBase1.vcont3,
                itemStyle: {
                  normal: {
                    lineStyle: {
                      color: "#a5a5a5",
                    },
                  },
                },
              },
              {
                name: "去年最高",
                type: "line",
                smooth: true,
                data: this.regBase1.vcont4,
                itemStyle: {
                  normal: {
                    lineStyle: {
                      color: "#ffc000",
                    },
                  },
                },
              },
              {
                name: "去年最低",
                type: "line",
                smooth: true,
                data: this.regBase1.vcont5,
                itemStyle: {
                  normal: {
                    lineStyle: {
                      color: "#5b9bd5",
                    },
                  },
                },
              },
            ],
          });
          myChart.on("click", (params) => {
            // alert(params.name.replace("月", ""));
            this.$emit("regA", params.name.replace("月", ""));
          });
        }, 200);
      }
    },
  },
};
</script>
